/* global FB */
import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { CssBaseline, CircularProgress, Container, Button, Grid, Avatar, Typography, TextField, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import DialogConfirmation from 'src/components/dialog-confirmation'
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import { AbilityContext } from '../../config/ability-context'
import { FormattedMessage, injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/rulesattendance';
import Api2Talk from "../../services/api2talk";
import Api from '../../services/api';
import * as RegistratioPhoneNumberRequestService from '../../services/2talk//registrationphonenumber';
import * as ServicePhoneRegistrationRequests from '../../services/2talk/phoneregistrationrequests';
import * as ServiceCompany from '../../services/2talk/company';
import { browserHistory } from '../../helpers/history';
import Title from '../../components/title-name';
import { QueuePlayNext, DeleteForever, Delete, ExpandMore, Add } from '@mui/icons-material';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import ColorlibStepIcon from '../../components/colorlib-step-icon';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import PhoneInput from 'react-phone-input-2'
import { PapiroConsole } from '../../utils/papiroConsole';
import Dropzone from 'react-dropzone';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import StepButton from '@mui/material/StepButton';
import DialogGeneral from '../../components/dialog-general';
import CheckIcon from '@mui/icons-material/Check';
import { DataGrid, GridToolbarFilterButton } from '@mui/x-data-grid';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PROVIDER_CONFIG, PROVIDER_CONFIG_NAME } from 'src/utils/enums/provider-config';
import DialogAddMultiple from 'src/components/dialog-add-multiple';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // Usa as variáveis CSS. Se o arquivo azul estiver carregado, isso será azul.
            backgroundImage: `linear-gradient( 95deg, var(--mexx-green-light) 0%, var(--mexx-green-primary) 50%, var(--mexx-green-dark) 100%)`,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // Mesma lógica para o completed
            backgroundImage: `linear-gradient( 95deg, var(--mexx-green-light) 0%, var(--mexx-green-primary) 50%, var(--mexx-green-dark) 100%)`,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

const NoDataRows = _ => {
    return (
        <div className="MuiDataGrid-window" style={{ display: 'flex', justifyContent: 'center', top: 56, overflowY: 'auto' }} >Não há registros a serem exibidos</div>
    )
}

class PhoneRegistrationRequestsRegistration extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;

        const intl = this.props.intl;

        //estado inicial da empresa
        this.initialcompanyRegistrationState = {
            companyNameName: '',
            companyAddress: '',
            companyWebsite: '',
            companyLogo: '',
            companyMainActivity: '',
            companyAccountId: '',
            companyPhone: '',
        }

        //estado inicial solicitação telefone
        this.initialItemState = {
            phoneNumber: "",
            messageproviderid: null,
            cnpj: "",
        }

        this.initialMetaAuthentication = {
            accountName: "",
            smsCode: "",
            messageProviderConfigAccountsid: "",
            accountId: "",
            phoneNumberId: "",
            templateNamespace: ""

        }

        this.state = {
            // LEGACY_META_IFRAME_FLOW: the previous flow loaded https://mexx.ai/login-meta-2talk.html in an iframe.
            // Keep the reference commented for rollback, but do not restore fixed Meta tokens in browser code.
            // urlRegisterMetaAccount: 'https://mexx.ai/login-meta-2talk.html',
            urlRegisterInstagramAccount: 'https://localhost:3000/instagramCode.html',
            companyRegistration: this.initialcompanyRegistrationState,
            item: this.initialItemState,
            metaAuthentication: this.initialMetaAuthentication,
            metaSignupConfig: {
                appid: '',
                graphapiversion: 'v22.0',
                configurationid: ''
            },
            metaSignupLoading: false,
            metaSignupFinished: false,
            metaCompanyAccountId: '',
            itemError: {
                cnpj: '',
            },
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            techinicalTeamList: [],
            usersList: [],
            files: [],
            conditionOptions: [{ id: 1, name: 'OU' }, { id: 2, name: 'E' }],
            messageProviderList: [],

            company: null,
            hasCompany: false,
            activeStep: 0,
            DialogRemoveState: false,
            verifiedState: false,
            verifiedStateMessenger: false,
            verifiedStateInstagram: false,
            instagramAuth: {
                code: '',
                accessToken: '',
                userId: '',
                username: ''
            },
            instagramLoading: false,
            instagramPopup: null,
            instagramMessageListener: null,
            instagramAccountId: null,
            steps: ['Provedor', 'Telefone', 'Dados', 'Consulta de CNPJ', 'Concluir Operação'],
            /*messengerAuth: {
                code: '',
                accessToken: '',
                pageId: '',
                pageName: ''
            }, */
            messengerLoading: false,
            messengerPopup: null,
            messengerMessageListener: null,
            messengerPagesIds: null,
        }

        this.metaSignupAuthorizationCode = null;
        this.metaSignupSessionData = null;
        this.metaSignupSessionSubmitted = false;
        this.metaSignupSessionTimer = null;



        this.closeNotification = this.closeNotification.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeCompanyRegistration = this.handleInputChangeCompanyRegistration.bind(this);
        this.handleInputChangeMetaAuthentication = this.handleInputChangeMetaAuthentication.bind(this);

    }







    componentDidMount() {

        /*
        LEGACY_META_IFRAME_FLOW:
        if (Api != null && (Api.getSassHirerId() == 1 || Api.getSassHirerId() == 15) || (document.location.host.indexOf("localhost") > -1) || (document.location.host.indexOf("192.168.") > -1) || (document.location.host.indexOf("homologa.") > -1)) {
            this.setState({
                urlRegisterMetaAccount: 'https://mexx.ai/login-meta-2talk-homologa.html',
            });
        }
        if (Api != null && (Api.getSassHirerId() == 15)  ) {
            this.setState({
                urlRegisterMetaAccount: 'https://mexx.ai/login-meta-2talk-speed-homologa.html',
            });
        }
        if (Api != null && (Api.getSassHirerId() == 1011) ) {
            this.setState({
                urlRegisterMetaAccount: 'https://mexx.ai/login-meta-2talk-speed.html',
            });
        }
        */
        // this.getMetaSignupConfig()
        this.getMessageProviders()
    }

    handleStep(step) {
        PapiroConsole.log(this.state.activeStep)
        PapiroConsole.log(step)
        if (this.state.activeStep > step) {
            this.setState({
                activeStep: step,
            });
        }

    };

    shouldSkipPhoneStep = (provider = this.state.item.messageproviderid) => {
        const providerId = provider && provider.id ? provider.id : provider;
        return providerId === PROVIDER_CONFIG_NAME.INSTAGRAM ||
            providerId === PROVIDER_CONFIG_NAME.MESSENGER;
    }

    getVisibleSteps = () => this.state.steps
        .map((label, stepIndex) => ({ label, stepIndex }))
        .filter(step => step.stepIndex !== 1 || !this.shouldSkipPhoneStep());



    metaRequest = async e => {



        this.setState({ loading: true })

        var metaValidation = this.metaValidations()

        var data = this.state.metaAuthentication;
        data.MessageProviderId = this.state.item.messageproviderid ? this.state.item.messageproviderid.id : 0

        if (metaValidation) {
            var result = await RegistratioPhoneNumberRequestService.metaRquest(this.state.metaAuthentication);

            PapiroConsole.log("result aqui 123")
            PapiroConsole.log(result)
            if (result && result.data && result.success) {

                this.setState(prevState => ({
                    metaAuthentication: {
                        ...prevState.metaAuthentication,
                        accountId: result.data.accountid,
                        phoneNumberId: result.data.phonenumberid,
                        templateNamespace: result.data.templatenamespace
                    },
                }));

                return true;


            } else {
                PapiroConsole.log("result error")
                PapiroConsole.log(result)
                const intl = this.props.intl
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result && result.errors ? result.errors[0] : intl.formatMessage({ id: "process.error" }),
                })
                Api.kickoff(result)
            }
        }


        return false

    }

    metaDataVerification = async e => {



        this.setState({ loading: true })

        var metaDataVerificationValidations = this.metaDataVerificationValidations()


        if (metaDataVerificationValidations) {
            let data = {
                accountName: this.state.metaAuthentication.accountName,
                phoneNumber: this.state.item.phoneNumber
            }
            var result = await RegistratioPhoneNumberRequestService.metaDataVerification(data);

            PapiroConsole.log("result aqui 123")
            PapiroConsole.log(result)
            if (result && result.data && result.success) {

                if (result && result.data && result.data[0]) {

                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: result.data[0]
                    })

                }

                this.setState({ verifiedState: true, loading: false })

                return true;


            } else {
                PapiroConsole.log("result error")
                PapiroConsole.log(result)
                const intl = this.props.intl
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result && result.errors ? result.errors[0] : intl.formatMessage({ id: "process.error" }),
                })
                Api.kickoff(result)
            }
        }


        return false

    }



    handleNext = async () => {
        this.setState({ loading: true });
        PapiroConsole.log("this.state.activeStep")
        PapiroConsole.log(this.state.activeStep)


        if (this.state.activeStep == 0) {

            if (!(this.state.item.messageproviderid?.id)) {

                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "É necessário selecionar o provedor do registro de número."
                });
                return;
            }

        }

        if (this.state.activeStep == 1) {
            if ((this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.TELEGRAM) && !this.isValidPhoneNumber(this.state.item['phoneNumber'])) {

                PapiroConsole.log((this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.TELEGRAM));
                PapiroConsole.log("Número de telefone inválido:", this.state.item['phoneNumber'])
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "É necessário um número de telefone válido"
                });
                return;
            }

            if (this.state.item['phoneNumber'] && this.state.item['phoneNumber'] != "" && (this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.TELEGRAM)) {
                var verifyResult = await RegistratioPhoneNumberRequestService.verifyPhoneExists(this.state.item['phoneNumber']);
                PapiroConsole.log("verifyResult")
                PapiroConsole.log(verifyResult)
                if (verifyResult.success == false && verifyResult.errors ) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: "error",
                        notificationMessage: verifyResult.errors ? verifyResult.errors[0] : "Já existe uma solicitação para esse número"
                    });
                    return;
                }
            }
        }

        else if (this.state.activeStep == 2) {
            if (this.state.item['messageproviderid'] != null && this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.INSTAGRAM && this.state.instagramAccountId == null) {

                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "É necessário conectar uma conta ao Instagram "
                });
                return;

            }

            if (this.state.item['messageproviderid'] != null &&
                this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.MESSENGER &&
                this.state.messengerPagesIds == null) {

                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "É necessário conectar uma conta ao Messenger"
                });
                return;
            }


            if (this.state.item['messageproviderid'] != null && this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.WHATSAPP) {

                var endpointValidation = await this.metaRequest()
                if (!endpointValidation) {
                    return;
                }

            }
        }


        else if (this.state.activeStep == 3) {
            PapiroConsole.log("entrei aqui")
            if (!this.state.item['cnpj'] || (this.state.item['cnpj'] && this.isCNPJValid(this.state.item.cnpj) == false)) {
                PapiroConsole.log("entrei aqui 2")
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: "O campo CPF/CNPJ não foi validado"
                });
                return;
            }

            var result = await ServiceCompany.getCompanyByCnpj(this.state.item['cnpj']);
            PapiroConsole.log(result)
            PapiroConsole.log("result")
            if (result.success) {
                if (result.data) {
                    this.setState({ company: result.data, hasCompany: true });
                }
                else {
                    this.setState({ company: null, hasCompany: false });
                }

            } else {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(result);
            }
        }







        this.setState((prevState) => ({
            activeStep: prevState.activeStep + (
                prevState.activeStep === 0 && this.shouldSkipPhoneStep(prevState.item.messageproviderid) ? 2 : 1
            ),
            loading: false
        }));


    };


    metaValidations() {

        var returnStatus = true;
        const intl = this.props.intl;
        var data = this.state.metaAuthentication
        PapiroConsole.log(this.state.metaAuthentication)
        PapiroConsole.log("this.state.metaAuthentication")

        if (this.state.verifiedState == false) {
            returnStatus = false;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "É necessária a verificação da conta antes de prosseguir para o próximo passo'",
            })
        }
        else {
            Object.keys(data).forEach(element => {
                PapiroConsole.log("entrei aqui")
                PapiroConsole.log(element)
                PapiroConsole.log(data[element])
                if (element == 'accountName' && data[element] === null) {
                    PapiroConsole.log("entrei aqui 2")

                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: "É necessário o preenchimento do campo 'Nome da conta'",
                    })

                    returnStatus = false;

                }
                else if (element == 'smsCode' && data[element] === null) {

                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: "É necessário o preenchimento do campo 'Informe aqui o código de sms recebido'",
                    })

                    returnStatus = false;

                }

            });
        }




        return returnStatus;


    }

    metaDataVerificationValidations() {

        var returnStatus = true;

        if (this.state.metaAuthentication.accountName == null || this.state.metaAuthentication.accountName == "") {

            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "É necessário o preenchimento do campo 'Nome da conta' para fazer a verificação",
            })
            returnStatus = false;

        }
        else if (this.state.item.phoneNumber == null || this.state.item.phoneNumber == "") {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "É necessário o preenchimento do campo 'Número de telefone origem da mensageria' para fazer a verificação",
            })

            returnStatus = false;
        }




        return returnStatus;


    }

    handleBack = () => {
        this.setState((prevState) => ({
            activeStep: prevState.activeStep - (
                prevState.activeStep === 2 && this.shouldSkipPhoneStep(prevState.item.messageproviderid) ? 2 : 1
            ),
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    getMessageProviders = async () => {

        var result = await ServicePhoneRegistrationRequests.getAllWithAccountSid()
        if (result.success) {
            // Filtrar messageproviderlist removendo IDs 1 e 6
            const filteredMessageProviderList = result.data.messageproviderlist.filter(provider =>
                provider.id !== 1 && provider.id !== 6
            );

            this.setState(prevState => ({
                metaAuthentication: {
                    ...prevState.metaAuthentication,
                    messageProviderConfigAccountsid: result.data.messageproviderconfigaccountsid,


                },
                loading: false, messageProviderList: filteredMessageProviderList
            }));

            // if (result.data.messageproviderconfigaccountsid) {
            //     this.initializeFacebookSDK(result.data.messageproviderconfigaccountsid);
            // }

        } else {
            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    }


    getMetaSignupConfig = async () => {
        const result = await RegistratioPhoneNumberRequestService.getMetaSignupConfig();
        if (result && result.success && result.data) {
            const metaSignupConfig = {
                appid: result.data.appid || '',
                graphapiversion: result.data.graphapiversion || 'v22.0',
                configurationid: result.data.configurationid || ''
            };
            const metaCompanyAccountId = result.data.companyaccountid || '';

            this.setState(prevState => {
                const nextState = {
                    metaSignupConfig,
                    metaCompanyAccountId
                };

                if (this.isMetaProvider(prevState.item.messageproviderid)) {
                    nextState.companyRegistration = {
                        ...prevState.companyRegistration,
                        companyAccountId: metaCompanyAccountId
                    };
                }

                return nextState;
            }, () => {
                this.initializeFacebookSDK(metaSignupConfig);
            });
            return metaSignupConfig;
        }
        return null;
    }

    initializeFacebookSDK = (metaSignupConfig = this.state.metaSignupConfig) => {
        this.ensureFacebookSDK(metaSignupConfig).catch(() => { });
    }

    ensureFacebookSDK = (metaSignupConfig = this.state.metaSignupConfig) => {
        return new Promise((resolve, reject) => {
            const appId = metaSignupConfig && metaSignupConfig.appid;
            const version = (metaSignupConfig && metaSignupConfig.graphapiversion) || 'v22.0';

            if (!appId) {
                reject(new Error('Meta App ID nao configurado.'));
                return;
            }

            window.fbAsyncInit = () => {
                window.FB.init({
                    appId,
                    cookie: true,
                    autoLogAppEvents: true,
                    xfbml: true,
                    version,
                });
                resolve();
            };

            if (window.FB) {
                window.fbAsyncInit();
                return;
            }

            const existingScript = document.getElementById('facebook-jssdk');
            if (existingScript) {
                existingScript.addEventListener('load', () => window.fbAsyncInit(), { once: true });
                existingScript.addEventListener('error', reject, { once: true });
                return;
            }

            const firstScript = document.getElementsByTagName('script')[0];
            const script = document.createElement('script');
            script.id = 'facebook-jssdk';
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://connect.facebook.net/en_US/sdk.js';
            script.onerror = reject;
            firstScript.parentNode.insertBefore(script, firstScript);
        });
    }

    // LEGACY_META_IFRAME_FLOW: kept only as a rollback reference. Do not restore fixed Meta tokens in browser code.
    initializeFacebookSDKLegacy = (messageproviderconfigaccountsid) => {

        // Define a função que será chamada quando o SDK do Facebook for carregado
        window.fbAsyncInit = () => {
            FB.init({
                appId: messageproviderconfigaccountsid,
                cookie: true, // enable cookies
                autoLogAppEvents: true,
                xfbml: true,
                version: "v20.0",
            });


        };

        // Carrega o SDK do Facebook
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk")
    }

    // LEGACY_META_IFRAME_FLOW: kept only as a rollback reference. Do not restore fixed Meta tokens in browser code.
    launchWhatsAppSignupLegacy() {
        // Launch Facebook login
        FB.login(
            function (response) {
                if (response.authResponse) {
                    // LEGACY_META_IFRAME_FLOW: fixed-token Graph validation was removed for security.
                } else {
                    console.log("User cancelled login or did not fully authorize.");
                }
            },
            {
                //scope: "business_management,whatsapp_business_management",
                scope: "email,whatsapp_business_messaging,public_profile,business_management,whatsapp_business_management",
                extras: {
                    feature: "whatsapp_embedded_signup",
                    setup: {
                        // ... // Prefilled data can go here
                    },
                },
            }
        );
    }

    handleConnectWhatsAppMeta = async () => {
        const intl = this.props.intl;
        let metaSignupConfig = this.state.metaSignupConfig;

        if (!metaSignupConfig.appid) {
            metaSignupConfig = await this.getMetaSignupConfig() || this.state.metaSignupConfig;
        }

        if (!metaSignupConfig.appid) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: 'Meta App ID nao configurado.',
            });
            return;
        }

        if (!metaSignupConfig.configurationid) {
            this.setState({
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: 'Meta configuration ID nao configurado.',
            });
            return;
        }

        this.metaSignupAuthorizationCode = null;
        this.metaSignupSessionData = null;
        this.metaSignupSessionSubmitted = false;
        if (this.metaSignupSessionTimer) {
            clearTimeout(this.metaSignupSessionTimer);
        }

        this.setState({ metaSignupLoading: true, metaSignupFinished: false });

        try {
            await this.ensureFacebookSDK(metaSignupConfig);
            window.removeEventListener('message', this.handleWhatsAppEmbeddedSignupMessage);
            window.addEventListener('message', this.handleWhatsAppEmbeddedSignupMessage);

            window.FB.login((response) => {
                if (response && response.authResponse && response.authResponse.code) {
                    this.metaSignupAuthorizationCode = response.authResponse.code;
                    if (this.metaSignupSessionTimer) {
                        clearTimeout(this.metaSignupSessionTimer);
                    }
                    if (this.metaSignupSessionData) {
                        this.submitMetaSignupSession();
                        return;
                    }

                    this.metaSignupSessionTimer = setTimeout(() => {
                        this.submitMetaSignupSession();
                    }, 1000);
                    return;
                }

                this.cleanupMetaSignupListener();
                this.setState({
                    metaSignupLoading: false,
                    openNotification: true,
                    notificationVariant: 'warning',
                    notificationMessage: 'Autenticacao Meta cancelada ou nao autorizada.',
                });
            }, {
                config_id: metaSignupConfig.configurationid,
                response_type: 'code',
                override_default_response_type: true,
                extras: {
                    feature: 'whatsapp_embedded_signup',
                    featureType: 'whatsapp_business_app_onboarding',
                    sessionInfoVersion: 3,
                    setup: {},
                },
            });
        } catch (error) {
            this.cleanupMetaSignupListener();
            this.setState({
                metaSignupLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "process.error" }),
            });
        }
    }

    handleWhatsAppEmbeddedSignupMessage = (event) => {
        let originAllowed = false;
        try {
            const hostname = new URL(event.origin).hostname;
            originAllowed = hostname === 'facebook.com' || hostname.endsWith('.facebook.com');
        } catch (error) {
            originAllowed = false;
        }

        if (!originAllowed) {
            return;
        }

        let eventData = event.data;
        if (typeof eventData === 'string') {
            try {
                eventData = JSON.parse(eventData);
            } catch (error) {
                return;
            }
        }

        if (!eventData || eventData.type !== 'WA_EMBEDDED_SIGNUP') {
            return;
        }

        const signupEvent = eventData.event || eventData.data?.event;
        const signupData = eventData.data || {};

        if (signupEvent === 'FINISH') {
            this.metaSignupSessionData = {
                event: signupEvent,
                wabaid: signupData.waba_id || signupData.wabaId || '',
                phonenumberid: signupData.phone_number_id || signupData.phoneNumberId || '',
                businessid: signupData.business_id || signupData.businessId || '',
            };

            if (this.metaSignupAuthorizationCode) {
                this.submitMetaSignupSession();
                return;
            }

            this.metaSignupSessionTimer = setTimeout(() => {
                this.submitMetaSignupSession();
            }, 1000);
            return;
        }

        if (signupEvent === 'CANCEL') {
            this.cleanupMetaSignupListener();
            this.setState({
                metaSignupLoading: false,
                openNotification: true,
                notificationVariant: 'warning',
                notificationMessage: 'Cadastro Meta cancelado pelo usuario.',
            });
            return;
        }

        if (signupEvent === 'ERROR') {
            this.cleanupMetaSignupListener();
            this.setState({
                metaSignupLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: signupData.error_message || signupData.message || 'Erro no cadastro Meta.',
            });
        }
    }

    submitMetaSignupSession = async () => {
        if (this.metaSignupSessionSubmitted) {
            return;
        }

        const sessionData = this.metaSignupSessionData || {};
        const payload = {
            code: this.metaSignupAuthorizationCode,
            event: sessionData.event,
            wabaid: sessionData.wabaid,
            phonenumberid: sessionData.phonenumberid,
            businessid: sessionData.businessid,
        };

        if (!payload.code && !payload.wabaid && !payload.phonenumberid && !payload.businessid) {
            return;
        }

        this.metaSignupSessionSubmitted = true;

        const result = await RegistratioPhoneNumberRequestService.metaSignupSession(payload);
        if (result && result.success) {
            const data = result.data || {};
            this.cleanupMetaSignupListener();
            this.setState(prevState => ({
                metaSignupLoading: false,
                metaSignupFinished: true,
                openNotification: true,
                notificationVariant: 'success',
                notificationMessage: 'Login Meta iniciado com sucesso. Continue a verificacao da conta.',
                metaAuthentication: {
                    ...prevState.metaAuthentication,
                    accountId: data.accountid || prevState.metaAuthentication.accountId,
                    phoneNumberId: data.phonenumberid || prevState.metaAuthentication.phoneNumberId,
                }
            }));
        } else {
            this.metaSignupSessionSubmitted = false;
            this.cleanupMetaSignupListener();
            this.setState({
                metaSignupLoading: false,
                metaSignupFinished: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: result && result.errors ? result.errors[0] : this.props.intl.formatMessage({ id: "process.error" }),
            });
        }
    }

    cleanupMetaSignupListener = () => {
        window.removeEventListener('message', this.handleWhatsAppEmbeddedSignupMessage);
        if (this.metaSignupSessionTimer) {
            clearTimeout(this.metaSignupSessionTimer);
            this.metaSignupSessionTimer = null;
        }
    }


    closeNotification() {
        this.setState({ openNotification: false });
    }

    changeValues = (stateName, value, text = "") => {
        this.setState(prevState => ({
            item: {
                ...prevState.item,
                [stateName]: value
            }
        }))
    }

    phoneRegistrationRequestValidation() {
        if (Api2Talk == null) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: "Api de mensageria não configurada."
            });
            return false;
        }

        if (this.state.item['messageproviderid'] == null || this.state.item['messageproviderid']?.id == 0) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "É necessário selecionar o provedor"
            });
            return false;
        }

        if ((this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item['messageproviderid']?.id == PROVIDER_CONFIG_NAME.TELEGRAM) && !this.isValidPhoneNumber(this.state.item['phoneNumber'])) {
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: "É necessário um número de telefone válido"
            });
            return false;
        }

        /* if (!this.state.item['cnpj'] && this.isCNPJValid(this.state.item.cnpj) == false) {
             this.setState({
                 loading: false,
                 openNotification: true,
                 notificationVariant: "error",
                 notificationMessage: "O campo CPF/CNPJ não foi validado"
             });
             return false;
         }
 
         if (this.state.hasCompany == false) {
 
             if (this.state.companyRegistration['companyName'] == null || this.state.companyRegistration['companyName'] == "") {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário preencher o campo 'Nome da empresa'"
                 });
                 return false;
             }
             if (this.state.companyRegistration['companyAccountId'] == null || this.state.companyRegistration['companyAccountId'] == "") {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário preencher o campo 'Número de Identificação do Gerenciador de Negócios'"
 
                 });
                 return false;
             }
             if (this.state.companyRegistration['companyMainActivity'] == null || this.state.companyRegistration['companyMainActivity'] == "") {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário preencher o campo 'Atividade principal da empresa'"
                 });
                 return false;
             }
             if (this.state.companyRegistration['companyAddress'] == null || this.state.companyRegistration['companyAddress'] == "") {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário preencher o campo 'Endereço'"
                 });
                 return false;
             }
             if (this.state.companyRegistration['companyPhone'] == null || this.state.companyRegistration['companyPhone'] == "") {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário preencher o campo 'Telefone'"
                 });
                 return false;
             }
             if (this.state.files.length <= 0 || this.state.files.length > 1) {
                 this.setState({
                     loading: false,
                     openNotification: true,
                     notificationVariant: "error",
                     notificationMessage: "É necessário adicionar um anexo para sua Logo"
                 });
 
                 return false;
             }
 
         }*/

        return true;
    }

    handleSubmit = async (e) => {
        if (e != null) {
            e.preventDefault();
        }
        let data = new FormData();
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        this.setState({ loading: true });
        const intl = this.props.intl;

        // validações do endpoint
        let phoneRegistrationRequestValidation = this.phoneRegistrationRequestValidation();
        if (phoneRegistrationRequestValidation) {
            for (let key in this.state.item) {
                if (key.toString().toLowerCase().indexOf('messageproviderid') > -1) {
                    data.append(key, this.state.item[key] ? this.state.item[key].id : null);
                }
                else {
                    data.append(key, this.state.item[key])
                }
            }
            if (this.state.hasCompany == false) {
                for (let key in this.state.companyRegistration) {
                    data.append(key, this.state.companyRegistration[key])
                }
                this.state.files.forEach(file => data.append('FilesUpload', file));

            } else {
                data.append("CompanyId", this.state.company ? this.state.company.id : null)
            }

            data.append("HasCompany", this.state.hasCompany)
            data.append("InstagramAccountId", this.state.instagramAccountId)
            // data.append("MessengerPagesIds", this.state.messengerPagesIds)
            if (this.state.messengerPagesIds != null && this.state.messengerPagesIds.length > 0) {
                this.state.messengerPagesIds.forEach(id => {
                    data.append("MessengerPagesIds", id);
                });
            }



            PapiroConsole.log("states aqui")
            PapiroConsole.log(this.state.item.messageproviderid)
            PapiroConsole.log(this.state.metaAuthentication.accountId)
            PapiroConsole.log(this.state.metaAuthentication.phoneNumberId)

            if (this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP) {
                data.append("AccountId", this.state.metaAuthentication.accountId)
                data.append("PhoneNumberId", this.state.metaAuthentication.phoneNumberId)
                data.append("AccountName", this.state.metaAuthentication.accountName)
                data.append("SmsCode", this.state.metaAuthentication.smsCode)
                data.append("TemplateNamespace", this.state.metaAuthentication.templateNamespace)
            }

            const { activeStep, steps } = this.state;

            if (activeStep != steps.length - 1) {

                data.append("CompanyNotProvided", true)
            }
            else {
                data.append("CompanyNotProvided", false)
            }

            Api2Talk.post('/registrationphonenumber', data, config)
                .then(result => {
                    if (result.data.success) {
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: "success",
                            notificationMessage: intl.formatMessage({ id: "save.success" }),
                            item: this.initialItemState,
                            companyRegistration: this.initialcompanyRegistrationState,
                            activeStep: 0,
                            files: [],
                            verifiedState: false,
                            verifiedStateMessenger: false,
                            verifiedStateInstagram: false,
                            instagramLoading: false,
                            instagramPopup: null,
                            instagramMessageListener: null,
                            instagramAccountId: null,


                        });
                        this.openOrCloseRemoveModal()
                        this.componentDidMount();
                    } else {
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: result.data && result.data.errors && result.data.errors[0] ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                        });
                        Api.kickoff(result);
                    }
                })
                .catch(err => {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(err);
                });
        }


        //dados para registro na tabela RegistrationNumberRequest

    }

    handleChangePhone = (e) => {

        this.setState(prevState => ({
            item: {
                ...prevState.item,
                ['phoneNumber']: e
            }
        }));
    }
    handleChangePhoneCompany = (e) => {

        this.setState(prevState => ({
            companyRegistration: {
                ...prevState.companyRegistration,
                ['companyPhone']: e
            }
        }));
    }

    // Valida se o número de telefone é válido
    isValidPhoneNumber = (phoneNumber) => {
        if (!phoneNumber || phoneNumber === "") {
            return false;
        }

        // Remove todos os caracteres não numéricos
        const cleanPhone = phoneNumber.replace(/\D/g, '');

        // Para Brasil (código do país 55):
        // Formato esperado: 55 + DDD (2 dígitos) + número (8 ou 9 dígitos)
        // Total: 12 ou 13 dígitos
        if (cleanPhone.startsWith('55')) {
            // Número brasileiro deve ter 12 (fixo) ou 13 (celular) dígitos
            return cleanPhone.length >= 12 && cleanPhone.length <= 13;
        }

        // Para outros países, valida se tem pelo menos 10 dígitos
        return cleanPhone.length >= 10;
    }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        if (name === 'cnpj') {

            var valor = 0;

            valor = this.CNPJMask(value)

            valor.length === 0 ? this.setState(prevState => ({ itemError: { ...prevState.itemError, cnpj: '' } })) : ((value.replace(/[.\-/]/g, '').length !== 14) || !this.isCNPJValid(value)) ? this.setState(prevState => ({ itemError: { ...prevState.itemError, cnpj: 'CPF/CNPJ inválido' } })) : this.setState(prevState => ({ itemError: { ...prevState.itemError, cnpj: '' } }))
            this.setState(prevState => ({
                item: {
                    ...prevState.item,
                    [name]: valor
                }
            }))
        }

    }

    handleInputChangeCompanyRegistration(e) {

        const name = e.target.name;
        const value = e.target.value;



        this.setState(prevState => ({
            companyRegistration: {
                ...prevState.companyRegistration,
                [name]: value
            }
        }))


    }


    handleInputChangeMetaAuthentication(e) {

        const name = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            metaAuthentication: {
                ...prevState.metaAuthentication,
                [name]: value
            }
        }))





    }

isCNPJValid(value) {
    if (!value) return false;
    const cleaned = value.replace(/[.\-/]/g, '').toUpperCase();
    if (cleaned.length !== 14) return false;

    const basePart = cleaned.substring(0, 12);
    const dvPart = cleaned.substring(12);

    if (!/^\d{2}$/.test(dvPart)) return false;

    const charToValue = (c) => c.charCodeAt(0) - 48;
    const calcDV = (seq) => {
        let sum = 0, peso = 2;
        for (let i = seq.length - 1; i >= 0; i--) {
            sum += charToValue(seq[i]) * peso;
            peso = peso === 9 ? 2 : peso + 1;
        }
        const resto = sum % 11;
        return (resto === 0 || resto === 1) ? 0 : 11 - resto;
    };

    const dv1 = calcDV(basePart);
    if (dv1 !== parseInt(dvPart[0])) return false;
    const dv2 = calcDV(basePart + dv1.toString());
    return dv2 === parseInt(dvPart[1]);
}



    CNPJMask = (valor) => {
    const cleaned = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    return cleaned
        .replace(/^(.{2})(.)/,        '$1.$2')
        .replace(/^(.{6})(.)/,        '$1.$2')
        .replace(/^(.{10})(.)/,       '$1/$2')
        .replace(/^(.{15})(.{1,2})$/, '$1-$2')
        .substring(0, 18);
};

    validateImagesAtachments(files) {


        const intl = this.props.intl;
        if (files.length > 1) {
            this.setState({
                evAttachFile: {},
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "checklist.modal.select.image.error" }),
            })
            return
        }
        else {
            this.setState({ files: files })
        }

    }
    removeItem(file) {
        let array = [...this.state.files];
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ files: array });
        }
    }

    openOrCloseRemoveModal = () => {
        this.setState({ DialogRemoveState: !this.state.DialogRemoveState })
    }

    isMetaProvider = (provider) => {
        const providerId = provider && provider.id ? provider.id : provider;
        return providerId == PROVIDER_CONFIG_NAME.WHATSAPP ||
            providerId == PROVIDER_CONFIG_NAME.INSTAGRAM ||
            providerId == PROVIDER_CONFIG_NAME.MESSENGER;
    }

    handleProviderSelect = (provider) => {
        const isMetaProvider = this.isMetaProvider(provider);

        this.setState(prevState => {
            const companyRegistration = { ...prevState.companyRegistration };

            if (isMetaProvider && prevState.metaCompanyAccountId) {
                companyRegistration.companyAccountId = prevState.metaCompanyAccountId;
            }

            if (!isMetaProvider && companyRegistration.companyAccountId === prevState.metaCompanyAccountId) {
                companyRegistration.companyAccountId = '';
            }

            return {
                item: {
                    ...prevState.item,
                    messageproviderid: provider
                },
                companyRegistration
            };
        }, () => {
            if (isMetaProvider && !this.state.metaCompanyAccountId) {
                this.getMetaSignupConfig();
            }
        });


    }

    getProviderConfig(provider) {
        return PROVIDER_CONFIG[provider.id] || { ...PROVIDER_CONFIG.default, name: provider.name };
    }

    handleConnectInstagram = async () => {
        this.setState({ instagramLoading: true });

        PapiroConsole.log("process.env.REACT_APP_MEXX_NSTAGRAM_CLIENT_ID")
        PapiroConsole.log(process.env.REACT_APP_MEXX_INSTAGRAM_CLIENT_ID)
        PapiroConsole.log(process.env.REACT_APP_MEXX_MESSENGER_HUB_URL)
        PapiroConsole.log(process.env);

        const instagramConfig = {
            clientId: process.env.REACT_APP_MEXX_INSTAGRAM_CLIENT_ID, // Substitua pelo seu Client ID
            redirectUri: `${window.location.origin}/pt/authorize-instagram`,
            scope: [
                "instagram_business_basic",
                "instagram_business_manage_messages",
            ].join(",")
        };

        // Construir URL de autorização
        const authUrl = new URL('https://www.instagram.com/oauth/authorize');
        authUrl.searchParams.append('force_reauth', 'true');
        authUrl.searchParams.append('client_id', instagramConfig.clientId);
        authUrl.searchParams.append('redirect_uri', instagramConfig.redirectUri);
        authUrl.searchParams.append('response_type', 'code');
        authUrl.searchParams.append('scope', instagramConfig.scope);

        // Calcular posição centralizada do popup
        const popupWidth = 500;
        const popupHeight = 700;
        const left = window.screenX + (window.outerWidth - popupWidth) / 2;
        const top = window.screenY + (window.outerHeight - popupHeight) / 2;

        const popupFeatures = `width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes,status=no`;

        // Abrir popup
        const popup = window.open(authUrl.toString(), 'instagram_oauth', popupFeatures);

        if (!popup) {
            this.setState({
                instagramLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: 'Não foi possível abrir o popup. Verifique o bloqueador de popups.'
            });
            return;
        }

        this.setState({ instagramPopup: popup });

        // Listener para receber o código
        let codeReceived = false;
        let checkPopupInterval = null;

        // Listener para receber o código
        const handleMessage = async (event) => {
            if (event.origin !== window.location.origin) {
                return;
            }

            if (event.data?.type === 'INSTAGRAM_OAUTH_RESPONSE') {
                // ✅ MARCA QUE CÓDIGO FOI RECEBIDO
                codeReceived = true;

                // ✅ LIMPA O INTERVAL IMEDIATAMENTE
                if (checkPopupInterval) {
                    clearInterval(checkPopupInterval);
                }

                window.removeEventListener('message', handleMessage);

                if (event.data.error) {
                    this.setState({
                        instagramLoading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: event.data.error_description || event.data.error
                    });
                    return;
                }

                if (event.data.code) {
                    console.log('✅ Código recebido:', event.data.code);
                    await this.exchangeInstagramCodeForToken(event.data.code);
                }
            }
        };

        window.addEventListener('message', handleMessage);

        // Monitorar se popup foi fechado manualmente
        checkPopupInterval = setInterval(() => {
            if (popup.closed) {
                clearInterval(checkPopupInterval);
                window.removeEventListener('message', handleMessage);

                // ✅ SÓ MOSTRA ERRO SE CÓDIGO NÃO FOI RECEBIDO
                if (!codeReceived) {
                    this.setState({
                        instagramLoading: false,
                        openNotification: true,
                        notificationVariant: 'warning',
                        notificationMessage: 'Autenticação cancelada pelo usuário.'
                    });
                }
            }
        }, 500);
    };



    exchangeInstagramCodeForToken = async (code) => {

        try {
            this.setState({
                loading: true
            });
            let data = new FormData();
            data.append('code', code);

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            };


            // Chama o endpoint do backend .NET
            const result = await Api2Talk.post('/registrationphonenumber/instagram/oauth/authorize', data, config);
            PapiroConsole.log("result instagram aqui")
            PapiroConsole.log(result)
            if (result && result.data && result.data.success === true) {

                const notificationVariant = result.data.notificationtype === 'info' ? 'info' : 'success';

                PapiroConsole.log("result.data.data.accountid")
                PapiroConsole.log(result.data.data.accountid)
                this.setState({
                    instagramLoading: false, // ✅ PARA O LOADING
                    verifiedStateInstagram: true, // ✅ MARCA COMO VERIFICADO
                    openNotification: true,
                    notificationVariant: notificationVariant,
                    notificationMessage: result.data.message || 'Instagram conectado com sucesso!',
                    instagramAccountId: result.data.data && result.data.data.accountid ? result.data.data.accountid : null,
                    loading: false
                });



            } else {
                this.setState({
                    instagramLoading: false, // ✅ PARA O LOADING
                    verifiedStateInstagram: false, // ✅ DESMARCA VERIFICADO
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: 'Erro ao obter token do Instagram. Tente novamente.',
                    loading: false
                });
            }
        } catch (err) {
            PapiroConsole.log("Erro ao processar OAuth do Instagram:", err);

            const responseMessage = err.response?.data?.message;
            const existingRegistrationUpdated = responseMessage &&
                responseMessage.indexOf('Registro já cadastrado na plataforma') !== -1;

            this.setState({
                instagramLoading: false,
                loading: false,
                openNotification: true,
                verifiedStateInstagram: existingRegistrationUpdated,
                notificationVariant: existingRegistrationUpdated ? "info" : "error",
                notificationMessage: responseMessage || "Erro ao conectar conta do Instagram.",
                loading: false
            });
        }



    };

    handleConnectMessenger = async () => {
        this.setState({ messengerLoading: true });

        PapiroConsole.log("Conectando Messenger...");
        PapiroConsole.log("Facebook App ID:", process.env.REACT_APP_FACEBOOK_APP_ID);

        const messengerConfig = {
            clientId: process.env.REACT_APP_FACEBOOK_APP_ID, // App ID do Facebook
            redirectUri: `${window.location.origin}/pt/authorize-messenger`,
            scope: [
                "pages_messaging",
                "pages_manage_metadata",
                "pages_read_engagement"
            ].join(",")
        };

        // Construir URL de autorização do Facebook
        const authUrl = new URL('https://www.facebook.com/v18.0/dialog/oauth');
        authUrl.searchParams.append('client_id', messengerConfig.clientId);
        authUrl.searchParams.append('redirect_uri', messengerConfig.redirectUri);
        authUrl.searchParams.append('response_type', 'code');
        authUrl.searchParams.append('scope', messengerConfig.scope);
        authUrl.searchParams.append('state', 'messenger_oauth'); // Para identificar o tipo de OAuth

        // Calcular posição centralizada do popup
        const popupWidth = 600;
        const popupHeight = 700;
        const left = window.screenX + (window.outerWidth - popupWidth) / 2;
        const top = window.screenY + (window.outerHeight - popupHeight) / 2;

        const popupFeatures = `width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes,status=no`;

        // Abrir popup
        const popup = window.open(authUrl.toString(), 'messenger_oauth', popupFeatures);

        if (!popup) {
            this.setState({
                messengerLoading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: 'Não foi possível abrir o popup. Verifique o bloqueador de popups.'
            });
            return;
        }

        this.setState({ messengerPopup: popup });

        let codeReceived = false;
        let checkPopupInterval = null;

        // Listener para receber o código
        const handleMessage = async (event) => {
            if (event.origin !== window.location.origin) {
                return;
            }

            if (event.data?.type === 'MESSENGER_OAUTH_RESPONSE') {
                codeReceived = true;

                if (checkPopupInterval) {
                    clearInterval(checkPopupInterval);
                }

                window.removeEventListener('message', handleMessage);

                if (event.data.error) {
                    this.setState({
                        messengerLoading: false,
                        verifiedStateMessenger: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: event.data.error_description || event.data.error
                    });
                    return;
                }

                if (event.data.code) {
                    console.log('✅ Código do Messenger recebido:', event.data.code);
                    await this.exchangeMessengerCodeForToken(event.data.code);
                }
            }
        };

        window.addEventListener('message', handleMessage);

        // Monitorar se popup foi fechado manualmente
        checkPopupInterval = setInterval(() => {
            if (popup.closed) {
                clearInterval(checkPopupInterval);
                window.removeEventListener('message', handleMessage);

                if (!codeReceived) {
                    this.setState({
                        messengerLoading: false,
                        openNotification: true,
                        notificationVariant: 'warning',
                        notificationMessage: 'Autenticação cancelada pelo usuário.'
                    });
                }
            }
        }, 500);
    };

    exchangeMessengerCodeForToken = async (code) => {
        try {
            let data = new FormData();
            data.append('code', code);

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "Accept": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            };

            try {
                // Chama o endpoint do backend .NET
                const result = await Api2Talk.post('/registrationphonenumber/messenger/oauth/authorize', data, config);

                PapiroConsole.log("Resultado Messenger OAuth:");
                PapiroConsole.log(result);

                if (result && result.data && result.data.success === true) {


                    const finalPages = result.data.data.pages;



                    this.setState({
                        messengerLoading: false,
                        verifiedStateMessenger: true,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: 'Messenger conectado com sucesso!',
                        messengerPagesIds: finalPages.map(page => page.pageid),


                        /*messengerAuth: {
                            code: code,
                            accessToken: result.data.data.accessToken || '',
                            pageId: result.data.data.pageId || '',
                            pageName: result.data.data.pageName || ''
                        }*/
                    });
                } else {
                    this.setState({
                        messengerLoading: false,
                        verifiedStateMessenger: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data?.errors?.[0] || 'Erro ao obter token do Messenger. Tente novamente.'
                    });
                }
            } catch (err) {
                PapiroConsole.log("Erro ao processar OAuth do Messenger:", err);

                this.setState({
                    messengerLoading: false,
                    verifiedStateMessenger: false,
                    openNotification: true,
                    notificationVariant: "error",

                    notificationMessage: err.response?.data?.message || "Erro ao conectar conta do Instagram.",
                });
            }
        } catch (error) {
            console.error('❌ Erro:', error);
            this.setState({
                messengerLoading: false,
                verifiedStateMessenger: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: 'Erro ao obter token do Messenger'
            });
        }
    };

    // Cleanup no componentWillUnmount
    componentWillUnmount() {
        this.cleanupMetaSignupListener();

        // Instagram cleanup
        if (this.state.instagramPopup && !this.state.instagramPopup.closed) {
            this.state.instagramPopup.close();
        }
        if (this.state.instagramMessageListener) {
            window.removeEventListener('message', this.state.instagramMessageListener);
        }

        // ✅ Messenger cleanup
        if (this.state.messengerPopup && !this.state.messengerPopup.closed) {
            this.state.messengerPopup.close();
        }
        if (this.state.messengerMessageListener) {
            window.removeEventListener('message', this.state.messengerMessageListener);
        }
    }


    render() {
        const { classes, headerMenu } = this.props;
        const { activeStep, itemError, companyRegistration } = this.state;
        const visibleSteps = this.getVisibleSteps();
        const stepperActiveStep = visibleSteps.findIndex(step => step.stepIndex === activeStep);

        const intl = this.props.intl;
        PapiroConsole.log("this.state.instagramAccountId")
        PapiroConsole.log(this.state.instagramAccountId)
        PapiroConsole.log("this.state.item")

        PapiroConsole.log(this.state.item)


        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='md'>
                        <CssBaseline />

                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        onClick={browserHistory.goBack}
                                    >
                                        {<FormattedMessage id="back" />}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={8} />
                            </Grid>
                            <Avatar mt={7} style={{ backgroundColor: '#303f9f', color: 'white' }}>
                                <AddIcCallIcon />
                            </Avatar>
                            <Typography component='h1' variant='h5' mt={2}>
                                Solicitar registro de novo provedor <Title />
                            </Typography>
                            <Stack sx={{ width: '100%' }} spacing={4} style={{ marginTop: '60px' }} >
                                <Stepper alternativeLabel activeStep={stepperActiveStep} connector={<ColorlibConnector />}>
                                    {visibleSteps.map(step => (
                                        <Step key={step.label}>
                                            <StepButton onClick={() => this.handleStep(step.stepIndex)}>

                                                <StepLabel StepIconComponent={ColorlibStepIcon}>{step.label}</StepLabel>
                                            </StepButton>

                                        </Step>
                                    ))}
                                </Stepper>
                                <div>
                                    {activeStep === 0 && (
                                        <Grid container spacing={3} style={{ marginTop: 15, marginBottom: '60px' }}>
                                            {/* <Grid item xs={12}>
                                                <Typography variant="h4" gutterBottom align="center" style={{ marginBottom: 24, fontWeight: 600 }}>
                                                    Selecione o provedor de mensageria
                                                </Typography>
                                            </Grid>*/}

                                            <Grid item xs={12}>
                                                <Grid container spacing={3} justifyContent="center">
                                                    {this.state.messageProviderList && this.state.messageProviderList.map((provider) => {
                                                        const config = this.getProviderConfig(provider);
                                                        const isSelected = this.state.item.messageproviderid?.id === provider.id;

                                                        return (
                                                            <Grid item xs={6} sm={4} md={3} lg={2} key={provider.id}>
                                                                <Paper
                                                                    elevation={isSelected ? 10 : 3}
                                                                    style={{
                                                                        // ANÁLISE E MELHORIA 3: Design do Card mais moderno
                                                                        borderRadius: '16px', // Bordas mais suaves
                                                                        padding: '24px',
                                                                        textAlign: 'center',
                                                                        cursor: 'pointer',
                                                                        height: '180px',
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        justifyContent: 'center', // Centraliza verticalmente o conteúdo
                                                                        alignItems: 'center',
                                                                        gap: '12px', // Espaço entre o ícone e o texto
                                                                        position: 'relative',

                                                                        // Transição suave para todas as propriedades
                                                                        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',

                                                                        // ANÁLISE E MELHORIA 4: Feedback de seleção mais forte e elegante
                                                                        border: isSelected ? '2px solid var(--mexx-green-primary)' : '2px solid transparent',


                                                                    }}
                                                                    onClick={() => this.handleProviderSelect(provider)}
                                                                    // ANÁLISE E MELHORIA 5: Efeito de hover refinado
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.transform = 'translateY(-6px)';
                                                                        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        // Mantém a elevação se estiver selecionado
                                                                        const originalElevationShadow = isSelected ? '0 10px 20px rgba(0,0,0,0.12)' : '0 3px 6px rgba(0,0,0,0.1)';
                                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                                        e.currentTarget.style.boxShadow = originalElevationShadow;
                                                                    }}
                                                                >
                                                                    {/* ANÁLISE E MELHORIA 6: Substituir o Radio por um ícone de "check" mais moderno */}
                                                                    {isSelected && (
                                                                        <CheckCircleIcon style={{

                                                                            position: 'absolute',
                                                                            top: 12,
                                                                            right: 12,
                                                                            fontSize: 28,
                                                                        }} />
                                                                    )}

                                                                    <div >
                                                                        {config.icon}
                                                                    </div>

                                                                    <Typography
                                                                        variant="h6"
                                                                        style={{

                                                                            fontSize: '1rem',
                                                                        }}
                                                                    >
                                                                        {provider.name || config.name}
                                                                    </Typography>
                                                                </Paper>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {activeStep === 1 && (
                                        <Grid container spacing={2} style={{ marginTop: 15 }}>
                                            {this.state.item.messageproviderid && this.state.item.messageproviderid.id && (this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.TELEGRAM) &&
                                                <Grid item xs={12}  >
                                                    <PhoneInput
                                                        inputStyle={{
                                                            padding: '23.5px 14px 23.5px 58px',
                                                            width: '100%'
                                                        }}
                                                        style={{
                                                            marginTop: 0,
                                                            marginBottom: 0
                                                        }}
                                                        id="phone"
                                                        name="phone"
                                                        country={'br'}
                                                        value={this.state.item.phoneNumber}
                                                        onChange={this.handleChangePhone}
                                                        InputLabel={this.props.intl.formatMessage({ id: "phone" })}
                                                        specialLabel="Número de telefone origem da mensageria "
                                                        inputProps={{
                                                            name: this.props.intl.formatMessage({ id: "phone" })
                                                        }}
                                                    />
                                                </Grid>}
                                        </Grid>
                                    )}
                                    {activeStep === 2 && (
                                        <Grid container spacing={2} style={{ marginTop: 15 }}>
                                            {this.state.item.messageproviderid && this.state.item.messageproviderid.id && this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP &&
                                                <Grid item xs={12}>
                                                    <Grid container columnSpacing={2}>
                                                        <Grid item xs={12} sm={12} md={6} lg={3} >
                                                            {/*
                                                            LEGACY_META_IFRAME_FLOW:
                                                            <iframe
                                                                src={this.state.urlRegisterMetaAccount}
                                                                width="100%"
                                                                height="50px"
                                                                style={{
                                                                    border: 'none',
                                                                    overflow: 'hidden',
                                                                }}
                                                                scrolling="no"
                                                            />
                                                            */}
                                                            <Button
                                                                onClick={this.handleConnectWhatsAppMeta}
                                                                disabled={this.state.metaSignupLoading}
                                                                fullWidth
                                                                variant='contained'
                                                                style={{
                                                                    backgroundColor: this.state.metaSignupFinished
                                                                        ? '#4CAF50'
                                                                        : this.state.metaSignupLoading
                                                                            ? '#9e9e9e'
                                                                            : '#1877f2',
                                                                    color: 'white',
                                                                    height: 40,
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold'
                                                                }}
                                                                startIcon={
                                                                    this.state.metaSignupLoading ? (
                                                                        <CircularProgress size={20} style={{ color: 'white' }} />
                                                                    ) : this.state.metaSignupFinished ? (
                                                                        <CheckIcon />
                                                                    ) : null
                                                                }
                                                            >
                                                                {this.state.metaSignupLoading
                                                                    ? 'Conectando...'
                                                                    : this.state.metaSignupFinished
                                                                        ? 'Meta conectada'
                                                                        : 'Entrar com a Meta'}
                                                            </Button>

                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={6} lg={3} style={{ fontWeight: 'bold' }}>

                                                            <Button

                                                                onClick={this.metaDataVerification}
                                                                style={{ color: this.state.verifiedState ? "#3f51b4" : "#fff", height: 40 }}
                                                                disabled={this.state.verifiedState ? true : false}
                                                                fullWidth
                                                                variant='contained'
                                                                color='secondary'
                                                                startIcon={this.state.verifiedState && <CheckIcon />}
                                                            >
                                                                {this.state.verifiedState ? "Verificado" : "Verificar"}
                                                            </Button>

                                                        </Grid>

                                                        <Grid item xs={12} >
                                                            <TextField
                                                                label="Nome da conta"
                                                                name="accountName"
                                                                value={this.state.metaAuthentication.accountName}
                                                                onChange={this.handleInputChangeMetaAuthentication}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                        </Grid>

                                                    </Grid>



                                                </Grid>



                                            }

                                            {this.state.item.messageproviderid && this.state.item.messageproviderid.id && this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.INSTAGRAM &&
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={12} md={6} lg={3}>
                                                            <Button
                                                                onClick={this.handleConnectInstagram}
                                                                disabled={this.state.instagramLoading || this.state.verifiedStateInstagram}
                                                                fullWidth
                                                                variant='contained'
                                                                style={{
                                                                    backgroundColor: this.state.verifiedStateInstagram
                                                                        ? '#4CAF50'
                                                                        : this.state.instagramLoading
                                                                            ? '#9e9e9e'
                                                                            : '#E4405F',
                                                                    color: 'white',
                                                                    padding: '12px 24px',
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                startIcon={
                                                                    this.state.instagramLoading ? (
                                                                        <CircularProgress size={20} style={{ color: 'white' }} />
                                                                    ) : this.state.verifiedStateInstagram ? (
                                                                        <CheckIcon />
                                                                    ) : null
                                                                }
                                                            >
                                                                {this.state.instagramLoading
                                                                    ? 'Conectando...'
                                                                    : this.state.verifiedStateInstagram
                                                                        ? 'Instagram Conectado'
                                                                        : 'Conectar Instagram'}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            }

                                            {this.state.item.messageproviderid &&
                                                this.state.item.messageproviderid.id &&
                                                this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.MESSENGER &&
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={12} md={6} lg={3}>
                                                            <Button
                                                                onClick={this.handleConnectMessenger}
                                                                disabled={this.state.messengerLoading || this.state.verifiedStateMessenger}
                                                                fullWidth
                                                                variant='contained'
                                                                style={{
                                                                    backgroundColor: this.state.verifiedStateMessenger
                                                                        ? '#4CAF50'
                                                                        : this.state.messengerLoading
                                                                            ? '#9e9e9e'
                                                                            : '#0084ff',
                                                                    color: 'white',
                                                                    padding: '12px 24px',
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold',
                                                                    transition: 'all 0.3s ease'
                                                                }}
                                                                startIcon={
                                                                    this.state.messengerLoading ? (
                                                                        <CircularProgress size={20} style={{ color: 'white' }} />
                                                                    ) : this.state.verifiedStateMessenger ? (
                                                                        <CheckIcon />
                                                                    ) : null
                                                                }
                                                            >
                                                                {this.state.messengerLoading
                                                                    ? 'Conectando...'
                                                                    : this.state.verifiedStateMessenger
                                                                        ? 'Messenger Conectado'
                                                                        : 'Conectar Messenger'}
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            }

                                            {this.state.item.messageproviderid && this.state.item.messageproviderid.id && this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP && this.state.verifiedState &&
                                                <Grid item xs={12} >
                                                    <TextField
                                                        label="Código pin enviado no processo de registro acima(SMS)"
                                                        name="smsCode"
                                                        value={this.state.metaAuthentication.smsCode}
                                                        onChange={this.handleInputChangeMetaAuthentication}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    )}
                                    {activeStep === 3 && (

                                        <div>
                                            <Grid item xs={12} sm={12}>
                                                <TextField
                                                    fullWidth
                                                    label={intl.formatMessage({ id: "cnpj" })}
                                                    inputProps={{ maxLength: 255 }}
                                                    autoComplete="fname"
                                                    type="cnpj"
                                                    variant="outlined"
                                                    name="cnpj"
                                                    onChange={this.handleInputChange}
                                                    value={this.state.item.cnpj}
                                                    InputLabelProps={{ shrink: true }}
                                                    error={itemError.cnpj?.length > 0}
                                                    helperText={itemError.cnpj}
                                                    required
                                                />
                                            </Grid>

                                            <Grid item xs={12} style={{ marginTop: 8, textAlign: 'right' }}>
                                                <Button
                                                    variant='text'
                                                    color='secondary'
                                                    onClick={this.openOrCloseRemoveModal}
                                                >
                                                    Pular etapas e concluir operação
                                                </Button>
                                            </Grid>





                                        </div>

                                    )}
                                    {activeStep === 4 && (

                                        <div>
                                            {this.state.hasCompany == true ?

                                                <Grid container spacing={2} style={{ marginTop: 15 }}>
                                                    <Grid item xs={12} mb={2}>
                                                        <Typography variant="h4" >
                                                            Dados da empresa
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                Nome da empresa:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.name : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>

                                                    <Grid item xs={12} >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                {intl.formatMessage({ id: "company.account.id" })} {this.state.item.messageproviderid && (this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.INSTAGRAM || this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.MESSENGER) ? "(Necessário conta verificada no Facebook)" : ""}:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.accountid : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>

                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                CNPJ:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.identificationnumber : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                Endereço:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.address : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                Website:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.website : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                Atividade Principal:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.mainactivity : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={12}  >
                                                        <Paper style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                                            <Typography variant="h6">
                                                                Número de telefone do chip:
                                                            </Typography>
                                                            <Typography variant="body1">
                                                                {this.state.company ? this.state.company.phone : null}
                                                            </Typography>
                                                        </Paper>
                                                    </Grid>
                                                </Grid>


                                                :
                                                <Grid container spacing={2} style={{ marginTop: 15 }}>


                                                    <Grid item xs={12} mb={2}>
                                                        <Typography variant="h4" >Registre sua empresa</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField label={intl.formatMessage({ id: "company.name" })} autoComplete='fname' variant='outlined' name='companyName' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.companyName} required fullWidth />
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <TextField label={intl.formatMessage({ id: "company.account.id" }) + ((this.state.item.messageproviderid && (this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.WHATSAPP || this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.INSTAGRAM || this.state.item.messageproviderid.id == PROVIDER_CONFIG_NAME.MESSENGER) ? "(Necessário conta verificada no Facebook)" : ""))} autoComplete='fname' variant='outlined' name='companyAccountId' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.companyAccountId} required fullWidth disabled={this.isMetaProvider(this.state.item.messageproviderid)} />
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <TextField label={intl.formatMessage({ id: "address" })} autoComplete='fname' variant='outlined' name='companyAddress' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.companyAddress} required fullWidth />
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <TextField label={intl.formatMessage({ id: "company.website" })} autoComplete='fname' variant='outlined' name='companyWebsite' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.companyWebsite} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <TextField label={intl.formatMessage({ id: "company.main.activity" })} autoComplete='fname' variant='outlined' name='companyMainActivity' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.companyMainActivity} required fullWidth />
                                                    </Grid>
                                                    <Grid item xs={12} >
                                                        <PhoneInput
                                                            inputStyle={{
                                                                padding: '23.5px 14px 23.5px 58px',
                                                                width: '100%'
                                                            }}
                                                            style={{
                                                                marginTop: 16,
                                                                marginBottom: 8
                                                            }}
                                                            id="phone"
                                                            name="companyPhone"
                                                            country={'br'}
                                                            value={companyRegistration.companyPhone}
                                                            onChange={this.handleChangePhoneCompany}
                                                            InputLabel={this.props.intl.formatMessage({ id: "company.chip.phone.number" })}
                                                            specialLabel="Telefone da empresa"
                                                            inputProps={{
                                                                name: this.props.intl.formatMessage({ id: "phone" })
                                                            }}
                                                        />
                                                    </Grid>


                                                    <Grid item xs={12} >
                                                        {/*<TextField label="Logo" autoComplete='fname' variant='outlined' name='logo' onChange={this.handleInputChangeCompanyRegistration} value={companyRegistration.logo} required fullWidth />*/}
                                                        <Grid item xs={12} sm={12}>
                                                            <section style={{ width: '100%' }}>
                                                                <div className={classes.dropzoneArea} style={{ minHeight: '70px', marginTop: '5px ' }}>
                                                                    <Dropzone onDrop={acceptedFiles => this.validateImagesAtachments([...acceptedFiles, ...this.state.files])}>
                                                                        {({ getRootProps, getInputProps, acceptedFiles }) => (
                                                                            <div {...getRootProps()}>
                                                                                <input {...getInputProps()} />
                                                                                <AttachFileIcon />
                                                                                <Typography component="span" fontWeight="bold" fontSize={16} color="gray">
                                                                                    <FormattedMessage id="drag.and.drop.logo" />
                                                                                </Typography>
                                                                            </div>
                                                                        )}
                                                                    </Dropzone>
                                                                    {this.state.files.map(file => {
                                                                        return (
                                                                            <div className={classes.dropzoneItem} key={file.name}>
                                                                                {file.name}
                                                                                <DeleteForever className={classes.deleteItem} onClick={() => { this.removeItem(file) }} />
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </section>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>


                                            }


                                        </div>

                                    )}

                                    <Grid container spacing={2} style={{ marginTop: '20px' }} >
                                        <Grid item xs={6}>

                                        </Grid>
                                        <Grid item xs={3}>
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={this.handleBack}
                                                fullWidth
                                                variant='contained'
                                                color='primary'
                                                className={classes.submit}
                                            >
                                                Voltar
                                            </Button>
                                        </Grid>


                                        <Grid item xs={3}>
                                            <Button
                                                onClick={activeStep === this.state.steps.length - 1 ? this.openOrCloseRemoveModal : this.handleNext}
                                                fullWidth
                                                variant='contained'
                                                color='primary'
                                                className={classes.submit}
                                            >
                                                {activeStep === this.state.steps.length - 1 ? 'Solicitar' : 'Próximo'}
                                            </Button>
                                        </Grid>

                                    </Grid>
                                    <Button >

                                    </Button>

                                </div>
                            </Stack>

                        </div>


                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                        <DialogGeneral
                            dialogTitle={this.props.intl.formatMessage({ id: "new.number.registration.request" })}
                            dialogSubTitle={this.props.intl.formatMessage({ id: "complete.this.operation" })}
                            open={this.state.DialogRemoveState}
                            openOrCloseModalFunction={this.openOrCloseRemoveModal}
                            handleConfirmation={this.handleSubmit}
                        />
                    </Container>
                </main>
            </div>
        );
    }
}
PhoneRegistrationRequestsRegistration.propTypes = {
    classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(PhoneRegistrationRequestsRegistration)));
PhoneRegistrationRequestsRegistration.contextType = AbilityContext;
